import React from 'react'
import FixtureBanner from './FixtureBanner'
import { FixtureSystem, FixtureProduct} from './FixtureProduct';
import { useState } from 'react';
import { fixtureItems, fixtureSystem } from './fixtureItems';
import { Structure } from '../../Structure/Components/Structure';
import { Link } from 'react-router-dom';
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { stepUp, stepBack } from '../../../Redux/Slice/stepSlice';




export const Fixture = () => {

  const dispatch = useDispatch()
  const steps = useSelector((state)=> state.step.value)

  return (
    <div>
      <FixtureBanner />
      <div>
      <div className="py-2 ">
        <div className="container">
          <div className="">
            <div className="">
              <div className="mb-5">
                <div className="">
                  <img src="/assets/images/Bitmap.png" alt="" className="bitmap" />
                </div>
                <div className="bois-de-pays mt-4">
                  <span className="text-2">SUPPORT</span>
                </div>
              </div>
            </div>

            <div className="row  " style={{ marginRight: 220 }}>
              {fixtureItems.map((product) => (
                <FixtureProduct key={product.id} product={product} />
              ))}
            </div>
                <div className="">
                  <div className="mb-3">
                    <div className="systeme-fixation">
                      <span className="text-2">VOTRE SYSTEME DE FIXATION</span>
                    </div>
                  </div>
                  <p className="mb-4">
                    Pour un chantier à moins de 5km des côtes choisissez nos vis inox
                    marin A4
                  </p>
                </div>
                <div className="row " style={{ marginRight: 220 }}>
                  {fixtureSystem.map((product, index) => (
                    <div key={index} className="col-md-4 col-sm-6 col-12 px-3 mb-4">
                      <FixtureSystem
                        imageUrl={product.imageUrl}
                        label={product.label}
                        showCheckbox={product.showCheckbox}
                      />
                    </div>
                  ))}
                </div>
                <div>
                <div>
          <div>
            <div className="mt-5">
              <div className="d-flex justify-content-center">
                <span className="bois-de-pays span text-2 me-2">
                  <Link to='/structureinstall' className="d-flex align-items-center " onClick={()=> dispatch(stepBack())}>
                      <FaLongArrowAltLeft className='me-3'  />  MODIFIEZ
                  </Link>
                    
                </span>
                <div className="btn btn-secondary box-green rounded-0">
                  <span className="text-2">
                    <Link to="/accessories" className='d-flex align-items-center ps-4' onClick={()=> dispatch(stepUp())}>
                      SUIVANT <FaLongArrowAltRight className='ms-2' />
                    </Link>
                    </span>
                </div>
              </div>
            </div>
            <div className="d-flex pt-5">
              <div className="m-auto">
                <nav aria-label="...">
                  <ul className="pagination pagination-sm rounded-0">
                    <li className="page-item">
                      <a className="page-link rounded-0" href="#">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link rounded-0 " href="#">
                        2
                      </a>
                    </li>
                    <li className="page-item active  rounded-0" aria-current="page">
                      <span className="page-link  rounded-0">3</span>
                    </li>
                    <li className="page-item">
                      <a className="page-link rounded-0 " href="#">
                        4
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}


export default Fixture